import {SVGProps} from "react";

// Android head from the V2 app promo (Figma "Icon / android", 78:852). Drawn on an
// 18px grid; pass width/height to scale (24 in the sidebar row, 22 in the button).
export const AndroidSvg = ({color = '#E4BD79', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path
            d="M5.25 3.75L3.75 1.5M12.75 3.75L14.25 1.5M3 9.75C3 8.1587 3.63214 6.63258 4.75736 5.50736C5.88258 4.38214 7.4087 3.75 9 3.75C10.5913 3.75 12.1174 4.38214 13.2426 5.50736C14.3679 6.63258 15 8.1587 15 9.75H3Z"
            stroke={color} strokeWidth="1.35" strokeLinecap="round"/>
        <path
            d="M13.5 10.5H4.5C3.67157 10.5 3 11.1716 3 12V14.25C3 15.0784 3.67157 15.75 4.5 15.75H13.5C14.3284 15.75 15 15.0784 15 14.25V12C15 11.1716 14.3284 10.5 13.5 10.5Z"
            fill={color}/>
        <path
            d="M6 8.25C6.41421 8.25 6.75 7.91421 6.75 7.5C6.75 7.08579 6.41421 6.75 6 6.75C5.58579 6.75 5.25 7.08579 5.25 7.5C5.25 7.91421 5.58579 8.25 6 8.25Z"
            fill={color}/>
        <path
            d="M12 8.25C12.4142 8.25 12.75 7.91421 12.75 7.5C12.75 7.08579 12.4142 6.75 12 6.75C11.5858 6.75 11.25 7.08579 11.25 7.5C11.25 7.91421 11.5858 8.25 12 8.25Z"
            fill={color}/>
    </svg>
)
